import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { AuthService } from 'src/app/api/core/auth/auth.service';
import { ModalFormParentComponent } from '../modal-form-parent/modal-form-parent.component';
import { PinInputComponent } from '../../shared/pin-input/pin-input.component';

import size from 'lodash/size';

@Component({
  selector: 'hub-pin-modal',
  templateUrl: './pin-modal.component.html',
  styleUrls: ['./pin-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PinModalComponent extends ModalFormParentComponent implements OnInit {
  /**
   * The pin input component
   */
  @ViewChild('hubPinInput', { static: true }) hubPinInput: PinInputComponent;

  @ViewChild('dummyContainer', { static: true }) dummyContainer: ElementRef;

  /**
   * The maximum available pin to enter
   */
  public REQUIRED_PIN_LENGTH: number = 4;

  /**
   * The close timeout instance
   */
  private _closeTimeout;

  /**
   * The start timeout instance
   */
  private _startTimeout;

  constructor(
    public modalCtrl: ModalController,
    public changeRef: ChangeDetectorRef,
    public auth: AuthService,
    public platform: Platform,
    public renderer: Renderer2,
  ) {
    super(platform, modalCtrl, renderer);
  }

  ngOnInit() {
    super.ngOnInit();
    this.keyboardParentTarget = this.dummyContainer;
  }

  ngAfterViewInit(): void {
    this.changeRef.detectChanges();

    // wait for the component to stop animating
    // focus after animation
    this._startTimeout = setTimeout(() => {
      this.hubPinInput.clearPinBox();
      this.hubPinInput.focusInput();
    }, 800);
  }

  /**
   * The pin input change listener
   * @param $event The new pin value
   */
  pinChanged($event): void {
    // check if pin value is valid
    // auto submit
    if ($event == this.auth.Admin_pin) {
      this.hubPinInput.lock();

      // resolve with VALID and close
      this._closeTimeout = setTimeout(() => {
        this.close(true);
      }, 1000);
    } else {
      // check if max value is reached
      // and validate
      if (size($event) == this.REQUIRED_PIN_LENGTH) {
        // if it's a mismatch, clear everything and marked boxes to invalid
        this._closeTimeout = setTimeout(() => {
          this.hubPinInput.clearPinBox();
          this.hubPinInput.markEmptyAsInvalid();
        }, 400);
      }
    }
  }

  /**
   * Closes the modal and resolves the result of pin validation
   * @param success If pin validation is successful
   */
  public close(success: boolean) {
    clearTimeout(this._closeTimeout);
    clearTimeout(this._startTimeout);

    this.modalCtrl.dismiss({ success: success });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    clearTimeout(this._closeTimeout);
    clearTimeout(this._startTimeout);
  }
}
